<template>
  <div class="d-flex justify-end">
    <v-menu
      bottom
      left
      offset-y
    >
      <template #activator="{ on, attrs }">
        <div class="d-flex align-center">
          <span class="caption">
            Sortuj po
          </span>

          <v-btn
            icon
            small
            v-bind="attrs"
            class="ml-1 pa-1"
            v-on="on"
          >
            <v-img
              v-if="order.length"
              src="/icons/icon_sort_on.svg"
              height="20"
              max-width="20"
              cover
            />

            <v-img
              v-else
              src="/icons/icon_sort_off.svg"
              height="20"
              max-width="20"
              cover
            />
          </v-btn>
        </div>
      </template>

      <v-list min-width="160">
        <v-list-item
          v-for="option in sortOptions"
          :key="option.value"
          dense
          @click="sortElements(order === option.value ? '' : option.value)"
        >
          <v-list-item-title :class="{'font-weight-bold' : option.value === order}">
            {{ option.label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      sortOptions: [
        { label: 'Najnowsze', value: 'created_at_descending' },
        { label: 'Najstarsze', value: 'created_at_ascending' },
      ],
    };
  },

  computed: {
    ...mapState('filters', [
      'order',
    ]),
  },

  methods: {
    ...mapActions('filters', [
      'setSorting',
    ]),

    sortElements(sortingOption) {
      this.setSorting(sortingOption)
        .then(() => {
          this.$emit('search');
        });
    },
  },
};
</script>
